import { render, staticRenderFns } from "./International4.vue?vue&type=template&id=3896e616&scoped=true&"
import script from "./International4.vue?vue&type=script&lang=js&"
export * from "./International4.vue?vue&type=script&lang=js&"
import style0 from "./International4.vue?vue&type=style&index=0&id=3896e616&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896e616",
  null
  
)

export default component.exports